import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/logo.png'
import _imports_1 from '@/assets/images/logo@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "logos-wr" }
const _hoisted_3 = { class: "logo-img-wr" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "logo-img-wr"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "spacing"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!$setup.isDesktop)
    ? (_openBlock(), _createBlock($setup["BuilderMobileHeader"], {
        key: 0,
        class: "header-with-estate-logo",
        estate: $setup.props.estate,
        builderLogo: $setup.props.builderLogo,
        skipStepIndex: $setup.props.skipStepIndex,
        onOnRequestQuotes: $setup.onRequestQuotes,
        isReviewQuote: $setup.props.isReviewQuote
      }, null, 8, ["estate", "builderLogo", "skipStepIndex", "isReviewQuote"]))
    : (_openBlock(), _createElementBlock("header", {
        key: 1,
        class: _normalizeClass(["header-with-estate-logo-desktop", { 'request-quote': $props.isReviewQuote }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            ($setup.props.estate?._id)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: $setup.props.estate?.logoUrl
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["to"]))
              : (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  to: "/"
                }, {
                  default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      srcset: _hoisted_1
                    }, null, -1)
                  ]))]),
                  _: 1
                }))
          ]),
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                ($setup.props.builderLogo)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: { name: 'EstateMap', params: { estateId: $setup.props.estate._id } }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          src: $setup.props.builderLogo
                        }, null, 8, _hoisted_6)
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "stepper", {}, undefined, true),
        _createVNode($setup["QuoteRequestCounter"], {
          onClick: $setup.onRequestQuotes,
          class: _normalizeClass({ hidden: $props.isReviewQuote })
        }, null, 8, ["class"]),
        ($props.isReviewQuote)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true)
      ], 2))
}